module.exports = __webpack_public_path__ + "img/icon2.c2487a76.png";